import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@common/auth/services/index';
import * as fromComponents from './components/index';
import * as fromServices from '../core/services/index';
import { kioskLockAppGuard } from '@app/features/erp-apps/restaurant/core/kiosk-lock.rule';

/* kzd r1 polish P5: these routes are ROOT routes too (the module is imported eagerly), so a device locked to the
   restaurant kiosk is sent back to it here as from every signed-in top-level address (product.routes.ts). */
const routes: Routes = [
  {
    path: 'tags',
    redirectTo: '/tags/home',
    pathMatch: 'full'
  },

  {
    path: 'tags',
    component: fromComponents.IndexComponent,
    canActivate: [AuthGuard, fromServices.TagPreloadGuard, kioskLockAppGuard],
    // resolve: {
    //   preload: MediaCampaignModuleResolve
    // },
    children: [
      {
        path: 'home',
        component: fromComponents.TagAdminComponent
        //canActivate: [AuthGuard]
      },
      {
        path: 'admin',
        component: fromComponents.TagAdminComponent
      }
    ]
  },
  {
    path: 'subscribe-topics',
    loadChildren: () => import('@common/tags/client/tags.-client.module').then(m => m.TagsClientModule),
    canActivate: [kioskLockAppGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TagsRoutingModule {}
